import React from "react";
import { connect } from "react-redux";
import { Formik, Form } from "formik";
import { Modal, Row, Col, Card } from "react-bootstrap";
import PropTypes from "prop-types";

import { allSensorParameters, allSensors } from "../../../../selector/common";
import Search from "./Search";
import Parameters from "./Parameters";
import MultiChart from "../../highchart/MultiChart";
import { commonConstants } from "../../../../constants";

function AnalysePopup({ openModal, toggleModal, initialValues, loading, graphData, submitForm }) {
  return (
    <React.Fragment>
      <Modal show={openModal} onHide={toggleModal} size="xl analyse-modal analyse">
        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          onSubmit={(values) => {
            submitForm(values);
          }}
        >
          {(props) => {
            const {
              values,
              touched,
              errors,
              handleChange,
              handleBlur,
              handleSubmit,
              submitCount,
              setFieldValue,
            } = props;

            return (
              <Form
                onSubmit={handleSubmit}
                className={"needs-validation" + (submitCount ? " was-validated1" : "")}
              >
                <Modal.Header>
                  <Modal.Title>Analyse</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                  {/* <pre>{JSON.stringify(values, null, 2)}</pre>
                  <pre>{JSON.stringify(errors, null, 2)}</pre> */}
                  {/* <pre>{JSON.stringify(touched, null, 2)}</pre> */}
                  <Card className="light-bg">
                    <Card.Body>
                      <Row>
                        <Col md={12} sm={12}>
                          <Search
                            values={values}
                            touched={touched}
                            errors={errors}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            handleSubmit={handleSubmit}
                            submitCount={submitCount}
                            setFieldValue={setFieldValue}
                            toggleModal={toggleModal}
                          />
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                  <Row>
                    <Col md={3}>
                      <Parameters
                        name="sensorParameters"
                        values={values}
                        touched={touched}
                        errors={errors}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        submitCount={submitCount}
                        setFieldValue={setFieldValue}
                        toggleModal={toggleModal}
                      />
                    </Col>
                    <Col md={9}>
                      <Card className="light-bg">
                        <Card.Body>
                          <MultiChart
                            height="333px"
                            //title={sensorParameter && sensorParameter["title"]}
                            //chart_type={sensorParameter && sensorParameter["graph_type"]}
                            //title="xxxxxxx"
                            chart_type={commonConstants.chartType.BAR}
                            chart_data={graphData}
                            loading={loading}
                          />
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Modal.Body>
              </Form>
            );
          }}
        </Formik>
      </Modal>
    </React.Fragment>
  );
}

// PropTypes validation
AnalysePopup.propTypes = {
  openModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  submitForm: PropTypes.func.isRequired,
  allSensorParameters: PropTypes.array.isRequired,
  allSensors: PropTypes.array.isRequired,
  graphData: PropTypes.array,
  loading: PropTypes.bool,
  initialValues: PropTypes.object,
  // Add PropTypes validation for Formik props
  values: PropTypes.object,
  touched: PropTypes.object,
  errors: PropTypes.object,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  handleSubmit: PropTypes.func,
  submitCount: PropTypes.number,
  setFieldValue: PropTypes.func,
};
function mapStateToProps(state) {
  return {
    allSensorParameters: allSensorParameters(state),
    allSensors: allSensors(state),
  };
}

export default connect(mapStateToProps)(AnalysePopup);
